import { render, staticRenderFns } from "./ProvinceListItem.vue?vue&type=template&id=551e464a&scoped=true"
import script from "./ProvinceListItem.vue?vue&type=script&lang=js"
export * from "./ProvinceListItem.vue?vue&type=script&lang=js"
import style0 from "./ProvinceListItem.vue?vue&type=style&index=0&id=551e464a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e464a",
  null
  
)

export default component.exports